import { useUserContext } from "../components/UserContextProvider";
import { useRoleParser } from "../hooks/permissions";

export function useAdminAccess() {
    const { user } = useUserContext();
    const { parseRoles, roles } = useRoleParser();

    const isAdmin = () => (parseRoles(user()?.permissions ?? 0, roles))[roles.indexOf("Admin")];
    const isRoot = () => (parseRoles(user()?.permissions ?? 0, roles))[roles.indexOf("Root")];

    return { isAdmin, isRoot, hasAdminAccess: () => isAdmin() || isRoot() };
}
